import { unstable_createMuiStrictModeTheme as createTheme } from '@mui/material';

function theme({ primary, sidebar, locale /* , sidebar_nested, sidebar_select */ }) {
  return createTheme(
    {
      breakpoints: {
        values: {
          xxs: 0,
          xs: 340,
          sm: 600,
          md: 1025,
          lg: 1284,
          ml: 1500,
          xl: 1920,
        },
      },
      palette: {
        primary: {
          main: primary || '#19857b',
        },
        secondary: {
          main: '#046b99',
        },
        sidebar: {
          main: sidebar || '#19857b',
        },
        font: {
          main: '#5b616b',
        },
        disabled: {
          main: '#BDBDBD',
        },
        success: {
          main: '#4BCC5A',
          contrastText: '#FFFFFF',
        },
        link: {
          main: '#0645AD',
        },
        error: {
          main: '#cd2026',
        },
        background: {
          default: '#F4F5F5',
          white: '#FFFFFF',
        },
      },
      custom: {
        boxShadow: '0px 2px 10px #00000029',
        marginTop: 130,
      },
      components: {
        MuiPickerStaticWrapper: {
          styleOverrides: {
            root: {
              width: '100%',
              '& > div > div': {
                width: '100%',
              },
            },
          },
        },
        MuiMonthPicker: {
          styleOverrides: {
            root: {
              width: '100%',
              margin: 0,
            },
          },
        },
        MuiCalendarPicker: {
          styleOverrides: {
            root: {
              width: '100%',
              '& div[role=row]': {
                justifyContent: 'space-evenly',
              },
              '& > div > div': {
                justifyContent: 'space-evenly',
              },
              '& > div > div > div': {
                justifyContent: 'space-evenly',
              },
            },
          },
        },
        MuiCssBaseline: {
          styleOverrides: {
            '.Toastify__toast-theme--colored.Toastify__toast--warning': {
              backgroundColor: 'rgb(255, 244, 229)',
              color: 'rgb(102, 60, 0)',
              '& svg': {
                color: '#ff9800',
              },
            },
            body: {
              '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
                backgroundColor: '#e6e5e5',
                width: 10,
                height: 5,
                borderRadius: 20,
              },
              '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
                borderRadius: 20,
                backgroundColor: '#70707095',
                minHeight: 24,
              },
              '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
                backgroundColor: '#707070',
              },
              '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
                backgroundColor: '#707070',
              },
              '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#707070',
              },
            },
          },
        },
      },
    },
    locale,
  );
}

export default theme;
